module.exports = __webpack_public_path__ + "0cc00e3a74408c79783eae4a98ab7a05.png";